function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape Copy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Logo-with-Text",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M24.5448046,0.357882951 C26.0193284,-0.369439364 27.8045539,0.225591927 28.5478444,1.69213125 L39.4383091,23.1794141 C40.1873445,24.6572882 39.596504,26.4625551 38.1186299,27.2115905 C38.1089441,27.2164996 38.0992318,27.221356 38.0894933,27.2261596 L29.926,31.252 L21.2377902,14.1085824 C20.7267435,13.1002686 19.6922894,12.464831 18.5618624,12.464831 L0,12.464831 L24.5448046,0.357882951 Z",
  id: "Combined-Shape-Copy",
  fill: "#758FFF"
}));

var SvgDlLogoIconOnly = function SvgDlLogoIconOnly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "40px",
    height: "32px",
    viewBox: "0 0 40 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDlLogoIconOnly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dl-logo-icon-only.2b7b736f.svg";
export { ForwardRef as ReactComponent };